import { Component, ChangeDetectionStrategy } from '@angular/core';
import Swal from '../../../shared/utils/swal.util';
import { MatDialog } from '@angular/material/dialog';
import { NotificacoesHistoricoDialogComponent } from './notificacoes-historico-dialog/notificacoes-historico-dialog.component';
import { NotificacoesDetalhesComponent } from './notificacoes-detalhes/notificacoes-detalhes.component';

@Component({
  selector: 'app-notificacoes',
  standalone: false,
  templateUrl: './notificacoes.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './notificacoes.component.css'
})
export class NotificacoesComponent {
  showNotifications = false;

  constructor(private dialog: MatDialog) { }

  notifications = [
    {
      type: 'success',
      typeLabel: 'Sucesso',
      title: 'Novo módulo disponível',
      subtitle: 'Sistema atualizado',
      text: 'O módulo "Editor da Home Page" foi adicionado ao sistema e está disponível para uso.',
      time: '14:30',
      lida: false
    },
    {
      type: 'warning',
      typeLabel: 'Aviso',
      title: 'Atualização de permissões',
      subtitle: 'Ação necessária',
      text: 'As permissões do usuário "Maria Silva" foram modificadas.',
      time: '11:15',
      lida: false
    },
    {
      type: 'info',
      typeLabel: 'Info',
      title: 'Backup concluído',
      subtitle: 'Sistema',
      text: 'O backup automático dos dados foi concluído com sucesso às 03:00.',
      time: '03:00',
      lida: false
    },
    {
      type: 'info',
      typeLabel: 'Info',
      title: 'Dados Atricon atualizados',
      subtitle: 'Conformidade',
      text: 'Novos critérios da cartilha Atricon foram adicionados ao sistema.',
      time: '03:00',
      lida: false
    },
    {
      type: 'danger',
      typeLabel: 'Alerta',
      title: 'Atenção: Prazo próximo',
      subtitle: 'Prestação de Contas',
      text: 'O prazo para envio da prestação de contas trimestral termina em 5 dias.',
      time: '09:00',
      lida: false
    }
  ];
  marcarTodasComoLidas() {
    this.notifications.forEach(n => n.lida = true);
  }
  get naoLidasCount(): number {
    return this.notifications.filter(n => !n.lida).length;
  }

  openHistory() {
    this.dialog.open(NotificacoesHistoricoDialogComponent, {
      width: '900px',
      maxWidth: '95vw'
    });
  }

  abrirDetalhes(notificacoes: any) {
    this.dialog.open(NotificacoesDetalhesComponent, {
      data: { notificacao: notificacoes },
      maxWidth: '950px',
      maxHeight: '100vh',
      autoFocus: false
    });
  }


  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
  }
}
